import * as t from 'io-ts';
import { withFallback } from 'io-ts-types/lib/withFallback';
import { authorizedTo, id, meta, users, entityType } from '../..';
import { formCodec as entityItemPropertyValueFormCodec } from '../entityItemPropertyValue/codec';

const data = t.type({
  title: t.string,
  description: withFallback(t.string, ''),
  entityType: t.union([entityType, t.null]),
  users,
  properties: withFallback(t.array(entityItemPropertyValueFormCodec), []),
});

export const recordCodec = t.type({
  id,
  data,
  authorizedTo,
});

export const listCodec = t.type({
  data: t.array(recordCodec),
  meta,
});

export const detailCodec = t.type({
  data: t.intersection([
    data,
    t.type({
      primarySsid: withFallback(t.string, ''),
      primaryPassword: withFallback(t.string, ''),
      secondarySsid: withFallback(t.string, ''),
      secondaryPassword: withFallback(t.string, ''),
    }),
  ]),
  authorizedTo,
});

export const formCodec = t.type({
  title: t.string,
  description: withFallback(t.string, ''),
  entityTypeId: t.union([t.number, t.null]),
  users: t.array(t.number),
  primarySsid: withFallback(t.string, ''),
  primaryPassword: withFallback(t.string, ''),
  secondarySsid: withFallback(t.string, ''),
  secondaryPassword: withFallback(t.string, ''),
  properties: withFallback(t.array(entityItemPropertyValueFormCodec), []),
});
